export function OAuthLink({
  href,
  icon,
  label,
  onClick,
}: {
  href: string;
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
}) {
  return (
    <a
      href={href}
      onClick={onClick}
      className='flex items-center justify-center gap-3 w-full px-4 py-3 border border-iq-grey-light rounded-lg text-sm font-medium text-iq-black hover:bg-iq-grey-100 transition-colors'>
      {icon}
      {label}
    </a>
  );
}
